module.exports = __webpack_public_path__ + "static/media/users.a17de5ec.svg";